<template>
  <div
    class="dropdown"
    :class="{ 'is-open': open }"
    role="button"
    @mouseenter="$emit('open')"
    @mouseleave="$emit('close')"
    @focusin="$emit('open')"
    @focusout="$emit('close')"
  >
    <button
      type="button"
      class="block c-white c-bg-transparent"
    >
      {{ category }}
      <i />
    </button>
    <no-ssr>
      <div
        :class="dropdownClasses"
      >
        <ul
          class="dropdown-grid"
          :style="dropdownColumns"
        >
          <li
            v-for="(item, index) in list"
            :key="index"
            class="dropdown-item"
          >
            <router-link
              class="block no-underline lh22 fs18"
              :to="categoryLink(item)"
            >
              {{ item.name }}
            </router-link>
          </li>
        </ul>
      </div>
    </no-ssr>
  </div>
</template>

<script>
import { formatCategoryLink } from '@vue-storefront/core/modules/url/helpers'
import NoSSR from 'vue-no-ssr'

export default {
  components: {
    'no-ssr': NoSSR
  },
  props: {
    rows: {
      type: Number,
      default: 4
    },
    list: {
      type: Array,
      default: () => []
    },
    category: {
      type: String,
      default: ''
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    columnCount () {
      const itemCount = this.list.length
      const maxRows = this.rows
      const columns = Math.ceil(itemCount / maxRows)

      return columns
    },
    dropdownColumns () {
      return {
        gridTemplateColumns: `repeat(${this.columnCount}, 1fr)`
      }
    },
    dropdownClasses () {
      return [
        'dropdown-content c-bg-white align-left lh20 regular',
        this.columnCount <= 1 ? 'single-column' : ''
      ]
    }
  },
  methods: {
    categoryLink (category) {
      return formatCategoryLink(category)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import "~theme/css/variables/grid";
$color-icon-hover: color(black);

.dropdown {
  position: relative;
  border-radius: 12px;

  button {
    display: flex;
    font-size: 22px;
    line-height: 27px;
    padding: 10px 20px;

    @include mediaQuery(null, 1240px) {
      padding: 10px 5px;
    }

    i {
      margin-left: 6px;
      display: inline-flex;
      align-self: center;
      width: 24px;
      height: 24px;
      background-image: url('/assets/icons/chevron-down.svg');
    }
  }

  &.is-open {
    background-color: color(white);
    border-radius: 12px 12px 0 0;

    button {
      background-color: transparent;
      color: black;

      i {
        background-image: url('/assets/icons/chevron-up-black.svg');
      }
    }
  }

  .dropdown-content {
    display: none;
    position: absolute;
    top: 100%;
    z-index: 2;
    border-radius: 0 12px 12px 12px;
  }

  .single-column {
    border-radius: 0 0 12px 12px;
    width: 100%;
  }

  @media (min-width: 768px) {
    &.is-open .dropdown-content {
      display: block;
    }
  }
}

.dropdown-grid {
  list-style: none;
  margin: 16px;
  padding: 0;
  display: grid;
  row-gap: 20px;
  column-gap: 40px;
  position: relative;
  overflow: hidden;
  grid-auto-flow: row;

  li:hover {
    color: color(primary);
    transition: all 0.3s;
    cursor: pointer;
  }

  .dropdown-item {
    display: inline-block;
    font-size: 18px;
    line-height: 22px;
    width: max-content;
    max-width: 150px;
    min-width: 100px;
    position: relative;
  }

  .dropdown-item::before {
    position: absolute;
    content: '';
    background-color: #eee;
    inline-size: 1px;
    block-size: 200%;
    inset-inline-start: -20px;
  }
}
</style>
